import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/setup/priceBook/initialState.billClass.data';
import {
  fetchBillClass as fetchBillClassAPI,
  searchBillClass as searchBillClassAPI,
  removeBillClass as removeBillClassAPI,
  addBillClass as billClassAddAPI,
} from '../../../../apis/priceBookAPI';
import { ACTIONS_BILL_CLASS } from '../../../../constants/actionCreator';
import {ERROR_MESSAGE} from '../../../../constants/index';

// API call for fetchBillClass
export const fetchBillClass = createAsyncThunk(
  ACTIONS_BILL_CLASS.FETCH_BILL_CLASS,
  async (body, { rejectWithValue }) => {
    try {
      const response = await fetchBillClassAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// API call for searchBillClass
export const searchBillClass = createAsyncThunk(
  ACTIONS_BILL_CLASS.SEARCH_BILL_CLASS,
  async (body, { rejectWithValue }) => {
    try {
      const response = await searchBillClassAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// API call for removeBillClass
export const removeBillClass = createAsyncThunk(
  ACTIONS_BILL_CLASS.REMOVE_BILL_CLASS,
  async (body, { rejectWithValue }) => {
    try {
      const response = await removeBillClassAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addBillClass = createAsyncThunk(
  ACTIONS_BILL_CLASS.ADD_BILL_CLASS,
  async (body, { rejectWithValue }) => {
    try {
      const response = await billClassAddAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const billClassSlice = createSlice({
  name: 'billClass',
  initialState,
  reducers: {
    billClassIdSet: (state, action) => {
      state.billClassId = action.payload;
    },
    searchGridDataSet: (state, action) => {
      state.searchGridData = action.payload;
    },
    showSearchGridSet: (state, action) => {
      state.showSearchGrid = action.payload;
    },
    isExpandedSet: (state, action) => {
      state.isExpanded = action.payload;
    },

    alertBoxOpenSet: (state, action) => {
      state.alertBoxOpen = action.payload;
      state.isBillClassNotRemoved= '';
    },
    handleModal: (state, action) => {
      state.isModalOpen = action.payload;
    },

    handleAddBillClassField: (state, action) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
    selectedValAddSet: (state, action) => {
      const {
        name,
        description,
        last_Modified_User_Id,
        last_Modified_TimeStamp,
      } = action.payload;
      state.selectedValAdd = {
        ...state.selectedValAdd,
        name,
        description,
        last_Modified_User_Id,
        last_Modified_TimeStamp,
      };
    },

    setSelectedValue: (state, action) => {
      state.selectedData[action.payload.name] = action.payload.value;
    },
    handleReset: () => initialState,

    resetValues: (state) => {
      state.selectedData = initialState.selectedData;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchBillClass.pending, (state) => {
        state.loading = true;
        state.isBillClassDataFound = false;
        state.billClassData = [];
        state.searchBill = []
      })
      .addCase(fetchBillClass.fulfilled, (state, action) => {
        state.loading = false;
        state.billClassData = action.payload[0]?.billClasses;
        state.billClassCount = action.payload[0]?.totalCount;
        state.isBillClassDataFound = true;
      })
      .addCase(fetchBillClass.rejected, (state) => {
        state.loading = false;
        state.isBillClassDataFound = false;
      })

      .addCase(searchBillClass.pending, (state) => {
        state.loading = true;
        state.isBillClassSearchDataFound = false;
        state.billClassData = [];
        state.searchBill = [];
        state.isBillClassSearched = false
        state.isBillClassDataFound = false;        
      })
      .addCase(searchBillClass.fulfilled, (state, action) => {
        state.loading = false;
        state.searchBill = action.payload[0]?.billClasses;
        state.billClassCount = action.payload[0]?.totalCount;
        state.isBillClassSearchDataFound = true;
        state.isBillClassSearched = true;
      })
      .addCase(searchBillClass.rejected, (state) => {
        state.loading = false;
        state.isBillClassSearchDataFound = false;
        
      })

      .addCase(removeBillClass.pending, (state) => {
        state.loadingRemoval = true;
        state.isBillClassRemoved = false;
        state.isBillClassNotRemoved = '';
      })
      .addCase(removeBillClass.fulfilled, (state, action) => {
        state.loadingRemoval = false;
        state.isBillClassNotRemoved = '';
        const data = [...state.billClassData];
        const searchData=[...state.searchBill];
        if(searchData.length>0){
          const indexToRemove = searchData.findIndex(
            (item) => item.bill_Class_Id === action.payload.bill_Class_Id
          );
          searchData.splice(indexToRemove, 1);
          state.searchBill = [...searchData];
        }else{
          const indexToRemove = data.findIndex(
            (item) => item.bill_Class_Id === action.payload.bill_Class_Id
          
          );
        
          data.splice(indexToRemove, 1);
          state.billClassData = [...data];
        }
        
        state.isBillClassRemoved = true;
        state.alertBoxOpen = false;
      })
      .addCase(removeBillClass.rejected, (state, action) => {
        state.loadingRemoval = false;
        state.isBillClassRemoved = false;
        state.isBillClassNotRemoved = action?.payload?.response?.data ? action?.payload?.response?.data : ERROR_MESSAGE.globalError;
      })

      .addCase(addBillClass.pending, (state) => {
        state.loading = true;
        state.isBillClassAdded = false;
        state.isBillClassAddDataFetched = true;
      })
      .addCase(addBillClass.fulfilled, (state, action) => {
        state.isBillClassAdded = true;
        state.loading = false;
        state.isBillClassAddDataFetched = false;
        state.searchGridData = [action.payload, ...state.searchGridData];
        state.billClassData = [action.payload, ...state.billClassData];
        state.isModalOpen = false;
        state.addName='';
        state.addDescription='';
      })
      .addCase(addBillClass.rejected, (state) => {
        state.isBillClassAdded = false;
        state.loading = false;
        state.isBillClassAddDataFetched = false;
      });
  },
});

export const {
  setIsSearchPage,
  handleReset,
  billClassIdSet,
  selectedValSet,
  selectedValAddSet,
  searchGridDataSet,
  showSearchGridSet,
  isExpandedSet,
  alertBoxOpenSet,
  handleModal,
  handleAddBillClassField,
  resetValues,
  cancelClickedSet,
  setSelectedValue,
} = billClassSlice.actions;
export default billClassSlice.reducer;
